import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { TypedMemo } from '../common/types';
import { clearInviteToken } from './teamInviteToken';
import { TeamAcceptStateCard } from './TeamAcceptStateCard';

/**
 * design: workspaces c3. An invite that was used, cancelled or has expired, from
 * `team.invitePreview` or from `team.accept`. No Join, and the stored token is dropped.
 */
const TeamAcceptInvalidInviteComponent: React.FC = () => {
  const intl = useIntl();

  useEffect(() => {
    clearInviteToken();
  }, []);

  return (
    <TeamAcceptStateCard
      tone="danger"
      icon={faEnvelope}
      title={intl.formatMessage({
        id: 'app.sml.team.accept.invalid.title',
        defaultMessage: 'This invite no longer works.',
      })}
      lead={intl.formatMessage({
        id: 'app.sml.team.accept.invalid.lead',
        defaultMessage: 'It was used, cancelled or has expired. Ask the person who invited you for a new one.',
      })}
      note={intl.formatMessage({
        id: 'app.sml.team.accept.invalid.ownerNote',
        defaultMessage: 'Invite links last 7 days. The owner sends a new one from Settings → Team.',
      })}
    />
  );
};

export const TeamAcceptInvalidInvite = TypedMemo(TeamAcceptInvalidInviteComponent);
